import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UrgencyStoreEffects } from './effects';
import { urgencyReducer } from './reducer';
import { UrgencyFacade } from './facade';
import { stateName } from './selectors';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature(stateName, urgencyReducer), EffectsModule.forFeature([UrgencyStoreEffects])],
  exports: [],
  providers: [UrgencyFacade],
  declarations: [],
})
export class UrgencyStateModule {}
